import { render, staticRenderFns } from "./CursoBiblicoInside.vue?vue&type=template&id=60e21458&scoped=true"
import script from "./CursoBiblicoInside.vue?vue&type=script&lang=js"
export * from "./CursoBiblicoInside.vue?vue&type=script&lang=js"
import style0 from "./CursoBiblicoInside.vue?vue&type=style&index=0&id=60e21458&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e21458",
  null
  
)

export default component.exports